import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'app-building-stronger',
  templateUrl: './building-stronger.component.html',
  styleUrls: ['./building-stronger.component.scss']
})
export class BuildingStrongerComponent implements OnInit {

  constructor() { }

  ngOnInit(): void {
  }

}
